import styled from 'styled-components';

export default styled.h3`
  font-size: 14px;
  letter-spacing: 1px;
  margin-top: 0;
  text-align: center;
  text-transform: uppercase;
  [class^='ss-'] {
    vertical-align: middle;
  }
`;



// WEBPACK FOOTER //
// ./src/components/SpecHeader.js